// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_Xwie1TqXnz","doubleBounce1":"doubleBounce1_3HzIIdgyTW","doubleBounce2":"doubleBounce2_1np4Zi8o_8","sk-bounce":"sk-bounce_-YL5G76OLh"};